// extracted by mini-css-extract-plugin
var _1 = "FundsAppStyle-module__button___TVdYP";
var _2 = "FundsAppStyle-module__buttonGreen___Gmlsu";
var _3 = "FundsAppStyle-module__buttonPurple___c5tlm";
var _4 = "FundsAppStyle-module__buttonPurpleDisabled___AFSxd";
var _5 = "FundsAppStyle-module__buttonRed___cyQSY";
var _6 = "FundsAppStyle-module__hideTabs___BVhp4";
var _7 = "FundsAppStyle-module__layout___fwetO";
var _8 = "FundsAppStyle-module__left___qtPK8";
var _9 = "FundsAppStyle-module__right___YVMTL";
var _a = "FundsAppStyle-module__tabs___ld9eb";
var _b = "FundsAppStyle-module__wrapper___hsD6J";
export { _1 as "button", _2 as "buttonGreen", _3 as "buttonPurple", _4 as "buttonPurpleDisabled", _5 as "buttonRed", _6 as "hideTabs", _7 as "layout", _8 as "left", _9 as "right", _a as "tabs", _b as "wrapper" }
